import React, { useState } from 'react';

export const LasPiezas = () => {
  const [selectedPiece, setSelectedPiece] = useState(null);

  const piezas = [
    {
      name: 'Utilitaria',
      type: 'Categoría',
      description: 'Tinajas, aripos, anafres, ollas, porrones. Piezas nacidas para el uso cotidiano que llevan siglos presentes en los hogares de la isla.',
      image: 'https://images.unsplash.com/photo-1772955898325-17a9643117e8'
    },
    {
      name: 'Decorativa',
      type: 'Categoría',
      description: 'Platos grabados con motivos geométricos, jarrones, alcancías. La estética de la arcilla llevada a las paredes y los espacios.',
      image: 'https://images.unsplash.com/photo-1771765502285-0ee5e168d9c8'
    },
    {
      name: 'Sagrada',
      type: 'Categoría',
      description: 'La Virgen del Valle, patrona de Venezuela y los pescadores. La pieza devocional más representativa de El Cercado.',
      image: 'https://images.unsplash.com/photo-1769791481759-98fc12052acc'
    }
  ];

  return (
    <section id="las-piezas" className="section-padding bg-cal-darker">
      <div className="editorial-container">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="nav-label text-siena">Las Piezas</span>
          <h2 className="display-heading text-4xl md:text-5xl lg:text-6xl text-earth mt-4 mb-6">
            Barro que se hace
            <br />
            <span className="text-ochre">patrimonio vivo</span>
          </h2>
          <p className="body-text text-lg">
            Cada pieza es única. No hay dos iguales. El fuego, el humo, las manos:
            todo deja su huella en la arcilla.
          </p>
        </div>

        {/* Gallery Grid - 3 categorías */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {piezas.map((pieza, index) => (
            <div
              key={index}
              onClick={() => setSelectedPiece(pieza)}
              className="group cursor-pointer bg-background rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={pieza.image}
                  alt={pieza.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-earth/70 via-earth/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>

              {/* Info */}
              <div className="p-5">
                <span className="text-xs text-siena uppercase tracking-wider font-medium">
                  {pieza.type}
                </span>
                <h3 className="display-heading text-xl text-earth mt-1">
                  {pieza.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <div className="mt-16 text-center max-w-2xl mx-auto">
          <p className="body-text text-base italic">
            Las piezas de El Cercado no se venden en línea. Cada compra es una conversación
            directa entre el artesano y quien aprecia su trabajo.
            Contáctanos para conocer disponibilidad.
          </p>
        </div>
      </div>

      {/* Modal for selected piece */}
      {selectedPiece && (
        <div
          onClick={() => setSelectedPiece(null)}
          className="fixed inset-0 z-50 bg-earth/90 backdrop-blur-sm flex items-center justify-center p-6 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-background rounded-lg max-w-2xl w-full overflow-hidden shadow-2xl"
          >
            <img
              src={selectedPiece.image}
              alt={selectedPiece.name}
              className="w-full h-96 object-cover"
            />
            <div className="p-8">
              <span className="text-sm text-siena uppercase tracking-wider font-medium">
                {selectedPiece.type}
              </span>
              <h3 className="display-heading text-3xl text-earth mt-2 mb-4">
                {selectedPiece.name}
              </h3>
              <p className="body-text text-base leading-relaxed">
                {selectedPiece.description}
              </p>
              <button
                onClick={() => setSelectedPiece(null)}
                className="mt-6 text-stone hover:text-earth transition-colors text-sm uppercase tracking-wider"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
